import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { Box, DateInput, InlineAlert } from '@cmpsr/components';
import { FC } from 'react';
import useDateController from './Date.controller';
import { DateProps } from './types';

export const DateComp: FC<DateProps> = ({ data, saveAnswer, defaultValue, whyWeAskModalDisclosure }) => {
  const { label, id, placeholder, whyWeAskExplanation, tooltip, description, validationValues } = data;
  const { defaultDate, onInputFn, form, validationOptions, onBlurFn } = useDateController({
    validationValues,
    saveAnswer,
    defaultValue,
  });

  return (
    <Box width="full" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Box mt={6}>
        <DateInput
          key={id}
          inputMode="numeric"
          variant="outline"
          placeholder={placeholder || 'MM/DD/YYYY'}
          defaultValue={defaultDate ?? undefined}
          mode="mm/dd/yyyy"
          textTransform="uppercase"
          borderColor={
            form.formState.errors.date?.message ? 'alert-error-default !important' : 'ui-element-outline-default'
          }
          {...form.register('date', validationOptions)}
          onInput={onInputFn}
          onBlur={onBlurFn}
        />
        {form.formState.errors.date?.message ? (
          <InlineAlert status="error" mt="spacer-6" alignItems="flex-start">
            <InlineAlert.Icon />
            <InlineAlert.Message>{form.formState.errors.date?.message}</InlineAlert.Message>
          </InlineAlert>
        ) : null}
      </Box>
    </Box>
  );
};
